import { render, staticRenderFns } from "./OptInAsAccreditedInvestor.vue?vue&type=template&id=4040bd9c&"
import script from "./OptInAsAccreditedInvestor.vue?vue&type=script&lang=js&"
export * from "./OptInAsAccreditedInvestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports